import React, { ReactElement, useState } from 'react'
import { Offcanvas } from 'react-bootstrap';

type Props = {
    showOffCanvas: Boolean;
    hideOffCanvas: Function;
    children: ReactElement;
}

const OffCanvasModal = ({showOffCanvas, hideOffCanvas, children}: Props) => {

  return (
    <Offcanvas scroll={false} placement='end' show={showOffCanvas} onHide={hideOffCanvas} className='w-25'>
        <Offcanvas.Header closeButton>
        </Offcanvas.Header>
        <Offcanvas.Body style={{marginTop: '-30px'}}>
          {children}
        </Offcanvas.Body>
      </Offcanvas>
  )
}

export default OffCanvasModal;